export function withAlpha(color: string, alpha: number): string {
  if (color.startsWith("rgba(")) {
    return color.replace(/,\s*[\d.]+\)\s*$/, `, ${alpha})`);
  }
  if (color.startsWith("rgb(")) {
    return color.replace("rgb(", "rgba(").replace(")", `, ${alpha})`);
  }
  if (color.startsWith("#")) {
    const raw = color.slice(1);
    const hex =
      raw.length === 3
        ? raw
            .split("")
            .map((c) => c + c)
            .join("")
        : raw.length === 8
          ? raw.slice(0, 6)
          : raw;
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    if ([r, g, b].some((n) => Number.isNaN(n))) return color;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return color;
}

/** V1.H hybrid item card — mirrors kraahl-mobile `lib/theme-tokens.ts`. */
export const itemCard = {
  photoBg: { light: "#e0ddd5", dark: "#16161a" },
  urgentPill: { bg: "#dc2626", fg: "#ffffff" },
  bookmarkScrim: withAlpha("#141416", 0.62),
  bookmarkSavedBg: "#ffffff",
  bookmarkSavedInk: "#0a0a0c",
  bookmarkCountInk: "#f4f4f5",
  pillSoftBg: withAlpha("#0e0e10", 0.88),
  pillSoftFg: "#f4f4f5",
  goneTint: withAlpha("#0a0a0c", 0.42),
  goneStampBorder: withAlpha("#ffffff", 0.85),
  goneStampFg: "#ffffff",
  pulsingDot: "#ffffff",
  stateAccent: {
    offers: "#4ee0a0",
    preorder: "#f0d089",
    own: "#f4f4f5",
  },
  layout: {
    shellGap: 6,
    bodyMinHeight: 70,
    bodyHeight: 70,
    titleBlockHeight: 32,
    titleLineHeight: 16,
    titleToPriceGap: 4,
    bottomRowHeight: 34,
    priceLineHeight: 18,
    priceSubLineHeight: 12,
    photoRadiusPx: 14,
  },
} as const;

export const ITEM_CARD_SKELETON_STRIP_WIDTH = 148;
